<template>
  <div :class="'wwi wwi-route--' + $router.currentRoute.name">
    <div class="wwi-container">
      <transition
        name="wwi-fade"
        mode="out-in"
      >
        <router-view />
      </transition>
    </div>
  </div>
</template>

<script>
import commonComponents from './components/common'
import formMixin from './mixins/form'
import i18n from './i18n'
import initRouter from './router'
import store from './store'
import Vue from 'vue'
import VueFloatLabel from 'vue-float-label'

for (let componentName of Object.keys(commonComponents)) {
  Vue.component(componentName, commonComponents[componentName])
}

Vue.use(VueFloatLabel)

Vue.mixin(formMixin)

initRouter()

export default {
  store,
  i18n,
  name: 'App',
  props: {
    contractor: {
      default: '',
      type: String
    }
  },
  data () {
    return {}
  },
  created () {
    this.$store.commit('general/SET_CONTRACTOR', this.contractor)
  }
}
</script>

<style lang="scss">
$borderRadius: 5px;

/* Font loaded by Website */
* {
  font-family: "museo-sans", sans-serif;
}

a {
  color: #dc0046;
  transition: color 0.3s ease-in-out 0s;
  &:hover {
    color: darken(#dc0046, 5%);
  }
}

.vfl-label {
  top: 0.2em;
  margin-left: 15px;
  transform: translateY(50%);
  font-size: 11px;
}

/* Float Label Hack */
.vfl-has-label {
  position: relative;
}
.vfl-label {
  position: absolute;
  top: 0;
  right: 0;
  left: 0.1em;
  overflow: hidden;
  font-family: sans-serif;
  font-size: 0.8em;
  color: #aaa;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  opacity: 0;
  transition: all 0.2s ease-out;
}
.vfl-label-on-input {
  top: -1.3em;
  pointer-events: all;
  opacity: 1;
}
.vfl-label-on-focus {
  color: #0074d9;
}
.vfl-has-label input:focus,
.vfl-has-label select:focus,
.vfl-has-label textarea:focus {
  outline: 0;
}

.vfl-label-on-input {
  top: 0.2em;
  margin-left: 15px;
  transform: translateY(0%);
  color: #dc0046;
  + input {
    padding: 20px 15px 10px;
  }
}

* {
  box-sizing: border-box;
}
.wwi {
  display: flex;
  justify-content: center;
  min-height: calc(100vh - 145px);
  color: white;
  padding: 60px 0;
  font-size: 16px;
  z-index: 1;
  transform: translate3d(0, 0, 0);
  background-color: #000;
  overflow: hidden;
  font-family: "museo-sans", sans-serif;
}

.wwi-background-image {
  position: absolute;
  z-index: -1;
  max-height: 100%;
}

#wwi-bg-start {
  right: 0;
  top: 50%;
  transform: translateY(-50%) translateX(-200px);
  opacity: 0;
  transition: all 0.3s ease-in 0s;
}

.wwi-route--start {
  #wwi-bg-start {
    transform: translateY(-50%) translateX(0px);
    opacity: 1;
    transition: all 0.3s ease-out 0.6s;
  }
}

#wwi-bg-email {
  left: 0;
  top: 50%;
  transform: translateY(-50%) translateX(200px);
  opacity: 0;
  transition: all 0.3s ease-in 0s;
}

.wwi-route--email {
  #wwi-bg-email {
    transform: translateY(-50%) translateX(0px);
    opacity: 1;
    transition: all 0.3s ease-out 0.6s;
  }
}

#wwi-bg-user {
  right: 0;
  top: 50%;
  transform: translateY(-50%) translateX(-200px);
  opacity: 0;
  transition: all 0.3s ease-in 0s;
}

.wwi-route--verify_email,
.wwi-route--userdata {
  #wwi-bg-user {
    transform: translateY(-50%) translateX(0px);
    opacity: 1;
    transition: all 0.3s ease-out 0.6s;
  }
}

#wwi-bg-domain {
  left: 50%;
  bottom: 0;
  transform: translateX(-50%) translateY(-200px);
  opacity: 0;
  transition: all 0.3s ease-in 0s;
}

.wwi-route--domain {
  #wwi-bg-domain {
    transform: translateX(-50%) translateX(0px);
    opacity: 1;
    transition: all 0.3s ease-out 0.6s;
  }
}

#wwi-bg-create-account {
  right: 0;
  top: 50%;
  transform: translateY(-50%) translateX(-200px);
  opacity: 0;
  transition: all 0.3s ease-in 0s;
}

.wwi-route--create_account {
  #wwi-bg-create-account {
    transform: translateY(-50%) translateX(0px);
    opacity: 1;
    transition: all 0.3s ease-out 0.6s;
  }
}

#wwi-bg-success {
  right: 0;
  top: 50%;
  transform: translateY(-50%) translateX(-200px);
  opacity: 0;
  transition: all 0.3s ease-in 0s;
}

.wwi-route--success {
  #wwi-bg-success {
    transform: translateY(-50%) translateX(0px);
    opacity: 1;
    transition: all 0.3s ease-out 0.6s;
  }
}

.wwi-route--start .wwi-header--title {
  font-size: 34px;
  img {
    vertical-align: baseline;
    margin-bottom: -2px;
  }
}

.wwi-container {
  width: 960px;
}

.wwi-fade-enter-active {
  transition: opacity 0.3s ease-in-out, transform 0.3s ease-out;
}

.wwi-fade-leave-active {
  transition: opacity 0.3s ease-in-out, transform 0.3s ease-in;
}

.wwi-fade-enter {
  opacity: 0;
  transform: translateY(100px);
}

.wwi-fade-leave-to {
  opacity: 0;
  transform: translateY(-100px);
}

.wwi-product {
  border-radius: $borderRadius;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.12);
  background-color: #f3f3f4;
  color: #000;
  width: 100%;
  margin: 0 10px;
  padding: 12px 25px 15px 25px;
  position: relative;
  &.wwi-product-rainbowify {
    &::after {
      content: "";
      background-image: url("/wwi-images/exklusiv-badge.png");
      background-size: contain;
      width: 155px;
      height: 155px;
      position: absolute;
      right: -50px;
      top: -65px;
    }
    .wwi-product--price {
      margin-top: 42px;
      margin-bottom: 15px;
    }
  }
  &:not(.wwi-product-rainbowify) {
    background-color: rgba(#fff, 0.8);
  }
}

.wwi-product--title {
  font-size: 24px;
  font-weight: 500;
}

.wwi-product--subtitle {
  font-size: 14px;
  color: #797a80;
}

.wwi-product--features {
  list-style: none;
  padding: 0 0 0 20px;
  margin-top: 15px;
  > li {
    position: relative;
    font-size: 14px;
    padding-bottom: 6px;
    &.wwi-product--feature-important {
      font-weight: 700;
    }

    svg {
      color: #57df83;
      fill: #57df83;
      stroke: #57df83;
      width: 14px;
      position: absolute;
      left: -20px;
      top: 4px;
    }
  }
}
.wwi-product--price {
  color: #797a80;
  margin: 0 0 5px 0;
  font-size: 14px;
}

.wwi-product--price-amount {
  font-size: 32px;
  font-weight: 500;
  color: #000000;
}

.wwi-button {
  font-family: "museo-sans", sans-serif;
  border-radius: $borderRadius;
  background-color: #dc0046;
  height: 50px;
  font-size: 16px;
  font-weight: 700;
  text-align: center;
  color: #ffffff;
  border: 0;
  outline: 0;
  transition: background-color 0.25s ease-in-out 0s;
  padding: 0 15px;
  margin-bottom: 5px;
  cursor: pointer;
  &.wwi-button-cta {
    width: 100%;
  }
  &.wwi-button-secondary {
    margin-right: 15px;
    background-color: #303133;
    &:hover {
      background-color: darken(#303133, 5%);
    }
  }
  &:hover {
    background-color: darken(#dc0046, 5%);
  }
}
.text-center {
  text-align: center;
}

.wwi-header--steps {
  margin-bottom: 25px;
}
.wwi-header--title {
  font-size: 24px;
  font-weight: 500;
  margin-bottom: 22px;
}

.wwi-header--intro {
  margin-top: 10px;
  margin-bottom: 25px;
}

input,
select {
  height: 50px;
  border-radius: $borderRadius;
  background-color: #ffffff;
  width: 100%;
  border: none;
  outline: none;
  padding: 15px;
  font-size: 15px;
  color: #000;
  margin-bottom: 15px;
}

.wwi-form--error {
  border-radius: $borderRadius;
  background-color: #ffccc3;
  color: #ff6347;
  &::placeholder {
    color: #ff6347;
  }
}

.wwi-step-form {
  max-width: 600px;
}

.wwi-form-zip-city-wrapper {
  display: flex;
  > * {
    width: 100%;
    &:first-child {
      width: 36%;
      margin-right: 15px;
    }
  }
}

.wwi-header--description {
  margin-bottom: 25px;
}

.wwi-header--error {
  border-radius: $borderRadius;
  background-color: #ff6347;
  padding: 10px 10px 10px 40px;
  margin-bottom: 25px;
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAYAAAAbBi9cAAAAAXNSR0IArs4c6QAAARpJREFUOBGdkbFqAlEQRfelCFgYsEtjJfkC8TtsLfIdtqazDrbaaeUXiL9hIUlsUkRsTCEEG1nPhL0yrO8t4sDdmXfn3pm3u1lWEXmet8C6QKtCWt1iwBIoltXqRBd3VxNc7ibkcRrjI/hyA1R+Wi/uirCI+3JGcj9iyUKZxPgM9wHqYAOmwOIV2Ac/gJcQwo6cDgZN3C3mUsLNHT8RH80I2+DkDAsJ4RaON01bPcsP/kD9XuLs9RRPKsjmM+11sKHnNqpcSQmxEulyT/3/TKMGvp1A5ZFiWMDqcpindhnG4a2sKM4/5E6BbUIz0G2aCP4SorG20R8nNOZtZjxmCYHRt9zIdNPAY8/WhjbfmX/tN47A8c4BZjPv6AzZ5+/xhUUi/AAAAABJRU5ErkJggg==');
  background-repeat: no-repeat;
  background-position: 10px center;
}

/* Fix hacky styles */
.circle {
  top: auto !important;
  height: 100px !important;
  margin: 0 !important;
}
</style>
